<template>
  <div>
    <div class="row row-cols-auto d-flex justify-content-center g-1 g-md-2">
      <div class="col d-flex align-items-center justify-content-center" v-if="difference.days !== '00'">
        <div class="px-1 px-md-3 py-3 text-center countdown-min-width" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h3 h1-md fw-bold">{{ difference.days }}</span>
          </div>
          <div>
            <small class="text-capitalize">{{ 'days' | translate }}</small>
          </div>
        </div>
      </div>
      <div class="col d-flex align-items-center justify-content-center" v-if="difference.hours !== '00'">
        <div class="px-1 px-md-3 py-3 text-center countdown-min-width" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h3 h1-md fw-bold">{{ difference.hours }}</span>
          </div>
          <div>
            <small class="text-capitalize">{{ 'hours' | translate }}</small>
          </div>
        </div>
      </div>
      <div class="col d-flex align-items-center justify-content-center">
        <div class="px-1 px-md-3 py-3 text-center countdown-min-width" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h3 h1-md fw-bold">{{ difference.minutes }}</span>
          </div>
          <div>
            <small class="text-capitalize">{{ 'minutes' | translate }}</small>
          </div>
        </div>
      </div>
      <div class="col d-flex align-items-center justify-content-center">
        <div class="px-1 px-md-3 py-3 text-center countdown-min-width" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h3 h1-md fw-bold">{{ difference.seconds }}</span>
          </div>
          <div>
            <small class="text-capitalize">{{ 'seconds' | translate }}</small>
          </div>
        </div>
      </div>
      
    </div>
    <div class="row">
      <div class="col-12 mt-5" v-if="showSlot">
        <slot></slot>
      </div>
      <div class="col-12 mt-5" v-else-if="difference.total <= 0 && $slots.aftercountdown">
        <slot name="aftercountdown"></slot>
      </div>
      <div class="col-12 text-center mt-5" v-else-if="difference.total <= 0">
        <h3>{{ afterCountdownText }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'

export default {
  props: ['afterCountdownText', 'testMode', 'seconds', 'customClasses', 'bgColorHex', 'textColorHex'],
  data() {
    return {
      interval: null,
      showSlot: false,
      countdownFinished: false,
      endDate: this.calculateEndDate(),
      difference: {
        total: 0,
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
    }
  },
  mounted() {
    this.difference = this.timerCount(this.endDate)
    // Set initial showSlot value based on countdown status
    this.showSlot = this.difference.total > 0

    this.interval = setInterval(() => {
      this.difference = this.timerCount(this.endDate)
      if (this.difference.total > 0) {
        this.showSlot = true
      } else if (this.difference.total <= 0 && !this.countdownFinished) {
        this.showSlot = false
        this.countdownFinished = true
        this.onCountdownFinished()
        this.$emit('countdown-finished')
        clearInterval(this.interval)
      }
    }, 1000)
  },
  methods: {
    addZero(number) {
      if (number < 10) {
        return `0${number}`
      }
      return number
    },
    onCountdownFinished() {
      document.cookie = 'promo_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    },
    timerCount(endDate) {
      endDate = dayjs(endDate)
      let now = dayjs()
      let diff = endDate.diff(now)

      if (diff < 0) {
        return {
          total: diff,
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        }
      }

      let total = diff
      let days = this.addZero(Math.floor(diff / (1000 * 60 * 60 * 24)))
      let hours = this.addZero(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
      let minutes = this.addZero(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)))
      let seconds = this.addZero(Math.floor((diff % (1000 * 60)) / 1000))

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      }
    },
    calculateEndDate() {
      const key = window.location.pathname.replaceAll('/', '_')
      if (this.testMode === 'true') {
        window.localStorage.removeItem(key)
      }
      const date = window.localStorage.getItem(key)
      if (date) {
        return dayjs.unix(date)
      }
      const countdownDate = dayjs().add(this.seconds, 'seconds')
      window.localStorage.setItem(key, countdownDate.unix())
      return countdownDate
    },
  },
  computed: {
    styles() {
      let styles = ''
      if (this.bgColorHex) {
        styles += `background-color: ${this.bgColorHex};`
      }
      if (this.textColorHex) {
        styles += `color: ${this.textColorHex};`
      }
      return styles
    },
    classes() {
      if (this.customClasses || this.bgColorHex || this.textColorHex) {
        return this.customClasses || ''
      }

      return 'bg-light'
    },
  },
}
</script>

<style>
.countdown-min-width {
  min-width: 80px;
}

@media (min-width: 768px) {
  .countdown-min-width {
    min-width: 120px;
  }
  
  .h1-md {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
}

@media (min-width: 1200px) {
  .h1-md {
    font-size: 2.5rem !important;
  }
}
</style>
